module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"user_grade":"用戶等級","author_grade":"創建者等級"}}')
  delete Component.options._Ctor
}
